import { X } from 'lucide-react';
interface SimplePDFViewerProps {
  url: string;
  onClose: () => void;
  title?: string;
}
export default function SimplePDFViewer({
  url,
  onClose,
  title,
}: SimplePDFViewerProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-2xl max-w-7xl h-[95dvh] sm:h-[95vh] w-full mx-4 flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <h3 className="text-lg font-semibold text-gray-900 truncate">
              {title || 'PDF Document'}
            </h3>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              title="Close"
            >
              <X size={18} />
            </button>
          </div>
        </div>
        {/* PDF Content */}
        <div className="flex-1 overflow-hidden">
          <iframe
            src={`/pdfjs/web/viewer.html?file=${encodeURIComponent(url)}`}
            title={title || 'PDF Document'}
            className="w-full h-full border-none"
          />
        </div>
      </div>
    </div>
  );
}
